import { render, staticRenderFns } from "./orgAlbum.vue?vue&type=template&id=bd40f3d6&scoped=true&"
import script from "./orgAlbum.vue?vue&type=script&lang=js&"
export * from "./orgAlbum.vue?vue&type=script&lang=js&"
import style0 from "./orgAlbum.vue?vue&type=style&index=0&id=bd40f3d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd40f3d6",
  null
  
)

export default component.exports